import { EmailCommunicationSetting } from './email-notifications-settings.model';
import { SmsCommunicationSetting } from './sms-notifications-settings.model';

export enum CommunicationSettingType {
  ScheduledConfirmation = 1,
  ChangedConfirmation = 2,
  CancelledConfirmation = 3,
  VisitReminder = 4,
  GiftCardPurchase = 5,
  FormsReminder = 6,
  CreditCardReminder = 7,
}

interface CommunicationSettings<T> {
  scheduledConfirmation: T;
  changedConfirmation: T;
  cancelledConfirmation: T;
  visitReminder: T;
  giftCardPurchase: T;
  formsReminder: T;
  creditCardReminder: T;
}

export type EmailCommunicationSettings = CommunicationSettings<EmailCommunicationSetting>;
export type SmsCommunicationSettings = CommunicationSettings<SmsCommunicationSetting>;
